import type { IBadgeLabelV2 } from './BadgeLabelV2';

import BadgeLabelV2 from './BadgeLabelV2';

export type { IBadgeLabelV2 };
export default BadgeLabelV2;
